<template>
	<form-field :label="label">
		<prime-input-mask v-bind="$attrs" />
	</form-field>
</template>

<script setup>
import FormField from '@/components/Form/Field.vue';
import PrimeInputMask from 'primevue/inputmask';

defineProps({
	label: String,
});
</script>
